import React from 'react';

export function TwoColumns({
  first,
  second,
}: {
  first: React.ReactNode;
  second: React.ReactNode;
}) {
  return (
    <div className="flex flex-col lg:flex-row gap-8">
      <div className="w-full lg:w-1/2 flex flex-col gap-6">{first}</div>
      <div className="w-full lg:w-1/2 flex flex-col gap-6">{second}</div>
    </div>
  );
}
